import { createSlice } from "@reduxjs/toolkit";

export type CookieConsentStatus = "unknown" | "accepted" | "rejected";

export const COOKIE_CONSENT_COOKIE_NAME = "flots_consent";
const COOKIE_CONSENT_MAX_AGE_SECONDS = 60 * 60 * 24 * 395; // ~13 mois (recommandation CNIL)

type CookieConsentState = {
  status: CookieConsentStatus;
};

function readConsentCookie(): CookieConsentStatus {
  if (typeof document === "undefined") return "unknown";

  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${COOKIE_CONSENT_COOKIE_NAME}=`));
  const value = match?.split("=")[1];

  if (value === "accepted" || value === "rejected") return value;
  return "unknown";
}

function writeConsentCookie(status: CookieConsentStatus) {
  if (typeof document === "undefined") return;

  if (status === "unknown") {
    document.cookie = `${COOKIE_CONSENT_COOKIE_NAME}=; path=/; max-age=0`;
    return;
  }

  document.cookie = `${COOKIE_CONSENT_COOKIE_NAME}=${status}; path=/; max-age=${COOKIE_CONSENT_MAX_AGE_SECONDS}; SameSite=Lax`;
}

const initialState: CookieConsentState = {
  status: "unknown",
};

const cookieConsentSlice = createSlice({
  name: "cookieConsent",
  initialState,
  reducers: {
    hydrate: (state) => {
      state.status = readConsentCookie();
    },
    accept: (state) => {
      state.status = "accepted";
      writeConsentCookie("accepted");
    },
    reject: (state) => {
      state.status = "rejected";
      writeConsentCookie("rejected");
    },
    reopen: (state) => {
      state.status = "unknown";
      writeConsentCookie("unknown");
    },
  },
});

export const { hydrate, accept, reject, reopen } = cookieConsentSlice.actions;
export default cookieConsentSlice.reducer;

export type { CookieConsentState };
